function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M128 128h85.3v85.3H128zM0 0h85.3v85.3H0zM128 256h85.3v85.3H128zM0 128h85.3v85.3H0zM0 256h85.3v85.3H0zM256 0h85.3v85.3H256zM128 0h85.3v85.3H128zM256 128h85.3v85.3H256zM256 256h85.3v85.3H256z"
});
function SvgCondensedFormat(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 341.3 341.3",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
export default __webpack_public_path__ + "07405703a1b5a6461e4948425642d4e1.svg";
export { SvgCondensedFormat as ReactComponent };